import { render } from "./AboutPage.vue?vue&type=template&id=218b4ada&scoped=true"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=218b4ada&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218b4ada"]])

export default __exports__